<template>
                      <h2 class="titleStepForm">Account Activity</h2>
                      <div class="row">
                        <!-- Optional validation: accFunded -->
                        <div class="col-lg-6">
                          <label class="font-size-14"
                            >How will account be funded</label
                          >
                          <div class="single-select2-cstm">
                            <Select2 placeholder="Select how the account is funded"
                              v-model="form.personal3.accFunded"
                              :class="{
                                'is-invalid': v$.form.personal3.accFunded.$error,
                              }"
                              :options="fundedoption"
                            />
                            <div
                              v-for="(personal3, index) in v$.form.personal3
                                .accFunded.$errors"
                              :key="index"
                              class="invalid-feedback"
                            >
                              <span v-if="personal3.$message">{{
                                personal3.$message
                              }}</span>
                            </div>
                          </div>
                        </div>

                        <div class="col-lg-6 mb-3">
                          <h4 class="font-size-14">
                            Are you a member of any other Credit Union / Financial
                            Institution?
                          </h4>
                          <p class="subTitleForm">
                            (Financial Institution e.g. Bank, UTC, Securities
                            Company)
                          </p>
                          <div class="row gx-3">
                            <div class="col-auto">
                              <label
                                for="yesAcc"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-0 pb-0"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal3.accountActi.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal3.accountActi"
                                  :value="true"
                                  name="accountActivity"
                                  class="inputRadioCstm d-none"
                                  id="yesAcc"
                                />
                                <span class="radioCircleIcon">
                                  <i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i>
                                  <i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i>
                                </span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  Yes
                                </h4>
                              </label>
                            </div>
                            <div class="col-auto">
                              <label
                                for="noAcc"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-0 pb-0"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal3.accountActi.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal3.accountActi"
                                  :value="false"
                                  name="accountActivity"
                                  class="inputRadioCstm d-none"
                                  id="noAcc"
                                />
                                <span class="radioCircleIcon">
                                  <i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i>
                                  <i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i>
                                </span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  No
                                </h4>
                              </label>
                            </div>

  <div v-if="v$.form.personal3.accountActi.$error" class="invalid-feedback d-block w-100"><span v-if="v$.form.personal3.accountActi.$errors[0]">{{ v$.form.personal3.accountActi.$errors[0].$message }}</span></div>
  </div>
                          <div
                            class="textareaShow"
                            v-if="form.personal3.accountActi == true"
                          >
                            <textarea placeholder="Enter details"
                              type="textarea"
                              v-model="form.personal3.accountActiDesc"
                              class="form-control resize-none"
                              rows="4"
                            ></textarea>
                          </div>
                          <!-- Optional validation: accountActiDesc -->
                        </div>

                        <div
                          class="col-lg-12"
                          v-if="form.personal3.accFunded === 'Other'"
                        >
                          <div class="form-group">
                            <label class="font-size-14">Enter Details </label>
                            <input placeholder="Enter details"
                              type="text"
                              v-model="form.personal3.other_details"
                              class="form-control"
                            />
                            <!-- Optional validation: other_details -->
                          </div>
                        </div>

                        <template v-if="!isEdit">
                        <!-- Optional validation: socuceofincome -->
                        </template>
                        <template v-if="isEdit">
                        <div class="col-lg-6">
                          <label class="font-size-14"
                            >Include source of income
                          </label>
                          <div class="single-select2-cstm">
                            <Select2 placeholder="Select source of income"
                              v-model="form.personal3.socuceofincome"
                              :options="Incomeoption"
                              :class="{
                                'is-invalid':
                                  v$.form.personal3.socuceofincome.$error,
                              }"
                            />
                            <div
                              v-for="(personal3, index) in v$.form.personal3
                                .socuceofincome.$errors"
                              :key="index"
                              class="invalid-feedback"
                            >
                              <span v-if="personal3.$message">{{
                                personal3.$message
                              }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <label class="font-size-14"
                            >Include the area for details to be captured.</label
                          >
                          <div class="single-select2-cstm">
                            <input placeholder="Enter details"
                              type="text"
                              v-model="form.personal3.areaofdetails"
                              class="form-control"
                              :class="{
                                'is-invalid':
                                  v$.form.personal3.areaofdetails.$error,
                              }"
                            />
                            <div
                              v-for="(personal3, index) in v$.form.personal3
                                .areaofdetails.$errors"
                              :key="index"
                              class="invalid-feedback"
                            >
                              <span v-if="personal3.$message">{{
                                personal3.$message
                              }}</span>
                            </div>
                          </div>
                        </div>
                        </template>
                        <template v-if="!isEdit">
                        <div class="col-lg-6">
                          <label class="font-size-14"
                            >Account Funding Details</label
                          >
                          <div class="single-select2-cstm">
                            <input placeholder="Enter details"
                              type="text"
                              v-model="form.personal3.areaofdetails"
                              class="form-control"
                              :class="{
                                'is-invalid':
                                  v$.form.personal3.areaofdetails.$error,
                              }"
                            />
                            <div
                              v-for="(personal3, index) in v$.form.personal3
                                .areaofdetails.$errors"
                              :key="index"
                              class="invalid-feedback"
                            >
                              <span v-if="personal3.$message">{{
                                personal3.$message
                              }}</span>
                            </div>
                          </div>
                        </div>
                        </template>

                        <div class="col-12 mb-3">
                          <br />
                          <h3 class="mb-2 font-size-18">
                            <template v-if="isEdit">
                            Grouping for 'anticipated level of activity'
                            </template>
                            <template v-if="!isEdit">
                            Anticipated level of activity
                            </template>
                          </h3>
                          <div class="row">
                            <div class="col-lg-6">
                              <div class="form-group">
                                <label class="font-size-14"
                                  >Number of transactions</label
                                >
                                <input placeholder="Enter number of transactions"
                                  type="number"
                                  inputmode="numeric"
                                  v-model="form.personal3.numTrans"
                                  @input="validatenumbrtrans"
                                  class="form-control"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal3.numTrans.$error,
                                  }"
                                />
                                <div
                                  v-for="(personal3, index) in v$.form.personal3
                                    .numTrans.$errors"
                                  :key="index"
                                  class="invalid-feedback"
                                >
                                  <span v-if="personal3.$message">{{
                                    personal3.$message
                                  }}</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-6">
                              <div class="form-group">
                                <label class="font-size-14"
                                  >Volume of Transactions (TT$)</label
                                >
                                <input placeholder="Enter volume of transactions"
                                  type="number"
                                  inputmode="numeric"
                                  v-model="form.personal3.volTrans"
                                  @input="validatevlumtrans"
                                  class="form-control"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal3.volTrans.$error,
                                  }"
                                />
                                <div
                                  v-for="(personal3, index) in v$.form.personal3
                                    .volTrans.$errors"
                                  :key="index"
                                  class="invalid-feedback"
                                >
                                  <span v-if="personal3.$message">{{
                                    personal3.$message
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
</template>

<script>
import Select2 from "vue3-select2-component";
import { bridge } from "../formBridge";

export default {
  name: "AccountActivityStep",
  props: {
    mode: { type: String, default: "create" },
  },
  computed: {
    isEdit() {
      return this.mode === "edit";
    },
  },
  mixins: [
    bridge({
    state: ["fundedoption", "form", "Incomeoption"],
    methods: ["validatenumbrtrans", "validatevlumtrans"],
    validate: true,
    }),
  ],
  components: { Select2 },
};
</script>